import styled, { css } from 'styled-components';
import { Buttons, FormTitle } from '../../../Shared/FormContainer/styled';
import { WrapperDefault } from '../../../Shared/Shared';

export const FormCalendarDateWrapper = styled(WrapperDefault)`
  @media (max-width: 1200px) {
    padding-right: 0;
    padding-left: 0;
    ${FormTitle},
    ${Buttons} {
      padding-left: 24px;
      padding-bottom: 18px;
    }
  }
`;

export const ScrollButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  margin-top: 10px;
`;

export const ScrollButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  cursor: pointer;

  &:hover {
    filter: brightness(0.8);
  }
`;

export const FormMonthsContainer = styled.div<{ isMultiday?: boolean; center?: boolean }>`
  margin-top: 32px;
  margin-bottom: 22px;
  transition: all 0.3s ease;
  width: 100%;

  display: grid;
  grid-template-columns: 40px 1fr 40px;
  ${props =>
    props.center &&
    css`
      grid-template-columns: 1fr;
    `}
  grid-template-rows: 1fr;
  gap: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1200px) {
    ${ScrollButtonContainer} {
      display: none;
    }
  }
  position: relative;
  ${({ isMultiday }) =>
    isMultiday &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;

export const FormMonths = styled.div<{ isMultiday?: boolean }>`
  display: flex;
  ${({ isMultiday }) =>
    isMultiday &&
    css`
      flex-direction: column;
      overflow-y: scroll;
      overflow-x: hidden;
    `}
  overflow-x: scroll;
  overflow-y: hidden;
  gap: 16px;
  padding-bottom: 20px;

  @media (max-width: 1200px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;
export const FormMonth = styled.div<{ isMultiday?: boolean }>`
  display: flex;
  gap: 22px;
  align-items: flex-end;
  ${({ isMultiday }) =>
    isMultiday &&
    css`
      flex-direction: column;
      align-items: flex-start;
    `}
  @media (max-width: 1200px) {
    margin-bottom: 0;
  }
`;

export const FormMonthTitle = styled.span`
  font-size: 18px;
  font-weight: 800;
  padding-bottom: 10px;
  color: var(--text-primary);
`;

export const BookingButtonContainer = styled.div<{
  isMultiday?: boolean;
  selectedDuration?: boolean;
  firstDay?: boolean;
  lastDay?: boolean;
  isLastDayInRow?: boolean;
  isFirstDayInRow?: boolean;
}>`
  display: flex;
  gap: 5px;
  ${({ isMultiday }) =>
    !isMultiday &&
    css`
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    `}

  ${({ isMultiday, isLastDayInRow }) =>
    isMultiday &&
    !isLastDayInRow &&
    css`
      width: 100%;
    `}

  ${({ selectedDuration, lastDay }) =>
    selectedDuration &&
    !lastDay &&
    css`
      background-color: var(--black);
    `}
    ${({ firstDay }) =>
    firstDay &&
    css`
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    `}

    ${({ isFirstDayInRow, firstDay }) =>
    isFirstDayInRow &&
    !firstDay &&
    css`
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    `}
`;

export const BookingButtonBackgroud = styled.div<{
  selectedDuration?: boolean;
  firstDay?: boolean;
  lastDay?: boolean;
  isLastDayInRow?: boolean;
  isFirstDayInRow?: boolean;
}>`
  display: flex;
  ${({ selectedDuration }) =>
    selectedDuration &&
    css`
      background-color: var(--black);
      color: var(--black);
    `}
  ${({ firstDay }) =>
    firstDay &&
    css`
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    `}
    ${({ lastDay }) =>
    lastDay &&
    css`
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    `}

  ${({ isLastDayInRow, lastDay }) =>
    isLastDayInRow &&
    !lastDay &&
    css`
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    `}

  ${({ isFirstDayInRow, firstDay }) =>
    isFirstDayInRow &&
    !firstDay &&
    css`
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    `}
`;

export const BookingButton = styled.div<{
  selectedDuration?: boolean;
  disabled: boolean;
  hidden?: boolean;
  circle?: boolean;
  empty?: boolean;
  bigCircle?: boolean;
  grey?: boolean;
  pill?: boolean;
}>`
  cursor: pointer;
  width: 66px;
  height: 63px;
  background-color: var(--white);
  border: solid 1px var(--black);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;

  span {
    font-size: 18px;
    font-weight: 800;
    color: var(--black);
  }

  ${({ circle }) =>
    circle &&
    css`
      width: 40px;
      height: 40px;
      border-radius: 20px;
      &:hover {
        background-color: var(--black);
        span {
          color: var(--white);
        }
      }
    `}

  ${({ bigCircle }) =>
    bigCircle &&
    css`
      width: 45px;
      height: 45px;
      border-radius: 22.5px;
      &:hover {
        background-color: var(--white);
      }
      span {
        font-size: 14px;
        font-weight: 800;
      }
    `}

  ${({ selectedDuration }) =>
    selectedDuration &&
    css`
      background-color: var(--black);
      span {
        color: var(--white);
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `}
  
  ${({ grey }) =>
    grey &&
    css`
      background-color: grey;
    `}

  ${({ hidden }) =>
    hidden &&
    css`
      opacity: 0;
      cursor: auto;
    `}
  
  ${({ empty }) =>
    empty &&
    css`
      background-color: transparent;
      border: none;
      cursor: auto;
      &:hover {
        background-color: transparent;
      }
    `}
  ${({ pill }) =>
    pill &&
    css`
      width: 100px;
      height: 40px;
      border-radius: 20px;
      margin-top: 20px;
      background-color: var(--white);
      color: var(--black);
      font-size: 16px;
      font-weight: 600;
      border: none;
      &:hover {
        background-color: var(--black);
        color: var(--white);
      }
    `}
`;

export const FormDateContainer = styled.div<{ isMultiday?: boolean }>`
  width: ${({ isMultiday }) => (isMultiday ? '100%' : 'auto')};
  input {
    position: absolute;
    opacity: 0;
    cursor: none;
    height: 0;
    width: 0;

    &:checked ~ ${BookingButtonContainer} {
      ${BookingButton} {
        background-color: var(--black);
        span {
          color: var(--white);
        }
      }
    }
  }
`;

export const FormDateLabelContainer = styled.div<{ isMultiday?: boolean; isRecurring?: boolean }>`
  display: flex;
  gap: 12px;

  ${({ isRecurring }) =>
    isRecurring &&
    css`
      gap: 32px;
    `}

  ${({ isMultiday }) =>
    isMultiday &&
    css`
      flex-wrap: wrap;
      gap: 0;
    `}
`;

export const FormDateLabel = styled.label<{ isMultiday?: boolean; isLastDayInRow?: boolean }>`
  user-select: none;
  height: 63px;
  ${({ isLastDayInRow, isMultiday }) =>
    !isLastDayInRow &&
    isMultiday &&
    css`
      flex: 1 0 14%;
      min-width: 14%;
      width: 14%;
    `}
`;

export const VerticalLine = styled.div`
  width: 1px;
  height: 60%;
  background-color: var(--white);
`;

export const DaysLabels = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: space-between;
  padding-right: 20px;

  @media (max-width: 1200px) {
    padding: 0;
  }
`;

export const DayLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);

  @media (max-width: 1200px) {
    font-size: 10px;
    width: 14%;
    min-width: 14%;
    max-width: 14%;
    text-align: center;
  }
`;

export const CalendarDayLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
`;
